var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrade(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.99,64.24c-4.55,0-8.77-3.47-9.6-7.9l-7.03-35.73h-7.81c-.7,0-1.15-.45-1.15-1.15s.44-1.16,1.15-1.16h8.73c.45,0,1.16,.47,1.16,.87l1.51,7.86h55.51c.45,0,.67,.22,.95,.5,.17,.16,.2,.54,.2,.67l-5.8,23.2c0,.48-.46,.94-.87,.94l-42.96,5.88,.22,.39c1.17,2.04,3.56,3.35,6.09,3.35h33.16c.71,0,1.15,.44,1.15,1.16s-.45,1.15-1.15,1.15H40.99Zm-7.22-8.38l42.95-5.59,5.08-21.22H28.4l5.36,26.82Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.82,81.7c-3.91,0-6.96-3.06-6.96-6.97s3.06-6.97,6.96-6.97,6.97,3.06,6.97,6.97-3.06,6.97-6.97,6.97Zm0-11.64c-2.48,0-4.66,2.18-4.66,4.67s2.18,4.66,4.66,4.66,4.66-2.18,4.66-4.66-2.18-4.67-4.66-4.67Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9,81.7c-3.91,0-6.97-3.06-6.97-6.97s3.06-6.97,6.97-6.97,6.97,3.06,6.97,6.97-3.06,6.97-6.97,6.97Zm0-11.64c-2.48,0-4.66,2.18-4.66,4.67s2.18,4.66,4.66,4.66,4.67-2.18,4.67-4.66-2.18-4.67-4.67-4.67Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrade);
export default __webpack_public_path__ + "static/media/trade.0bf582dc725b0fc27029ab7830ba1047.svg";
export { ForwardRef as ReactComponent };